module.exports = __webpack_public_path__ + "static/media/2.25db8e01.png";